import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noOpeningPriceUseCurrentQuoteInsteadBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Opening price could not be retrieved. Current bid/ask will be used
        instead.{' '}
      </Body3>
    </td>
  );
}
